import { Alert, Button, Form, FormGroup, Input, Label, Spinner } from 'reactstrap';
import styles from './ForgotPasswordPage.module.scss';
import { useRef, useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { useOnChangeHandler } from '../../../global/utils/hooks/useOnChangeHandler';
import { AppContext, UserContext } from '../../../global/globalContext/context';
import { postRequest } from '../../../global/utils/apiCall';
import { showMsg } from '../../../global/langs/langs';

const FORGOT_PASSWORD ='api/v1/user/forgot-password';

export default function ForgotPasswordPage() {
  const { lang } = useContext(UserContext);
  const { setting } = useContext(AppContext);

  const successRef = useRef();
  const emailRef = useRef();

  const [email, setEmail, onChangeEmail] = useOnChangeHandler('');

  const [ isLoading, setIsLoading ] = useState(false);
  const [success, setSuccess] = useState(false);
  const [ message, setMessage] = useState('');



  useEffect(() => {
    emailRef.current.focus();
  },[]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);
    setSuccess(false);
    try {
      const response = await postRequest(FORGOT_PASSWORD,JSON.stringify({email}));
      setSuccess(true);
      setMessage(response?.data?.message);
    }
    catch (error) {
      setIsLoading(false);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
    }
    finally{
      setIsLoading(false);
    }
  }


  return (
    <>
      <div className={`d-flex align-items-center justify-content-center ${styles.loginContainer}`}>
        <div className={`${styles.login} lgtBackground bg-white p-4`}>
          <Alert aria-live="assertive"
              color={success ? 'success' : 'danger'}
              innerRef={successRef}
              className={message ? `` : `d-none`}
              >
                {message}
          </Alert>
          <Link to='/' className=''>
            {
            setting
              ? <img src={`${`${process.env.REACT_APP_API_URL}${setting.logo
              }`}`} alt="letgo or trade logo" width={'120px'} className={`my-3`}/>
              : ''
            }
          </Link>
          <div className='fw-bold mb-3 '>
            Forgot Password
          </div>
          <Form className='mb-3' onSubmit={handleSubmit}>
            <FormGroup floating>
              <Input 
                id="forgot-email"
                type='text'
                value={email}
                placeholder='Email'
                innerRef={emailRef}
                onChange={onChangeEmail}
                required
                />
              <Label>
                Email
              </Label>
              </FormGroup>
              <Button 
                block 
                className={`general-button fw-semibold largBtn mb-3`}
                disabled={!email || isLoading ? true : false}
                >
                 {
                  isLoading 
                    ? (
                      <>
                        <Spinner size="sm">
                          Loading...
                        </Spinner>
                        <span>
                          {' '}Loading
                        </span>
                      </>
                    )
                    : showMsg('send', lang)
                }
              </Button>
          </Form>
        </div>
      </div>
    </>
  )
}
